export const ISSUES_FOR_BUNITO_REQUEST = "ISSUES_FOR_BUNITO_REQUEST";
export const ISSUES_FOR_BUNITO_SUCCESS = "ISSUES_FOR_BUNITO_SUCCESS";
export const ISSUES_FOR_BUNITO_FAILED = "ISSUES_FOR_BUNITO_FAILED";